import React from 'react'
import styles from '../Proj5Folder/Proj5.module.css'
import osra from '../../Images/osra1.jpeg'






export default function Hospital6() {
  return (

    <>
        <div className="container my-5 py-5 ">
          <div className="row align-items-center">
            <div className="col-md-6">
                <h3 className={`${styles.color} my-3`}> AL Osra Hospital ​</h3>
                <p> Project description: Hospital Building  </p>
                <p>Type of contract: Design </p>
                <p> Area:  1881.00 m2  </p>
                <p>Type of works : Architectural coordination's and Electromechanical </p>
            </div>
            <div className="col-md-6">
                <img src={osra} alt="achegy" className='img-fluid'/>
            </div>   
          </div>
      
        </div>

    </>
  )
}
